import { isMobileDevice, isIOSDevice } from './deviceDetection';

export const setupMobileViewport = () => {
  if (isMobileDevice()) {
    const viewport = document.querySelector('meta[name=viewport]');
    if (viewport) {
      if (isIOSDevice()) {
        // iOS-specific viewport settings for better fullscreen-like experience
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=no, viewport-fit=cover, minimal-ui');
      } else {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, user-scalable=no, viewport-fit=cover, minimal-ui');
      }
    }
  }
};

export const createIOSFullscreenExperience = () => {
  if (isIOSDevice()) {
    // Hide address bar on iOS by scrolling
    window.scrollTo(0, 1);
    
    // Add CSS to hide browser UI
    const style = document.createElement('style');
    style.innerHTML = `
      body {
        overflow: hidden;
      }
      html, body {
        height: 100vh;
        height: 100dvh; /* Dynamic viewport height for mobile */
      }
    `;
    document.head.appendChild(style);
    
    console.log('🔍 [FULLSCREEN] Applied iOS fullscreen experience');
    return true;
  }
  return false;
};